var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container mb-5"},[_c('productlisttable',{ref:"prodlisttable"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }